import UserAccountMenu from 'src/components/UserAccountMenu/UserAccountMenu';
import { connect } from 'react-redux';
import { FrameworkActionCreator, CustomerActionCreator, AppointmentActionCreator, VehiclesActionCreator, RepairOrdersActionCreator, NewVehicleActionCreator, ROHistoryActionCreator, MenusActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    customerInfo: state.Customer.Customer,
    specInfo: state.Specs.specs,
    viewApptList: state.Appointment.ViewApptList,
    selectedVehicle: state.Vehicles.selectedVehicle,
    profileNum: state.Framework.specProfile,
    store: state.Framework.store,
    branch: state.Framework.branch,
    repairOrders: state.RepairOrders ?? '',
    vehicles: state.Vehicles,
    theme: state.Framework.theme,
    serviceDocsSpecs: state.Specs.serviceDocsSpecs,
    newTabUrl: state.Framework.newTabUrl,
    locale: state.Framework.locale,
    roHistory: state.ROHistory.allRoHistory,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    employeeFlag: state.Customer.Customer.employeeFlag ?? false,
    oemCustSearchLaunched: state.Framework.toyotaCustSearchLaunched === 'Y' || state.Framework.lexusCustSearchLaunched === 'Y' ||
        state.Framework.lexusTDCSLaunched === 'Y' || state.Framework.toyotaTDCSLaunched === 'Y',
    loading: state.Customer.loading,
    gmMemberErr: state.Customer.gmMemberErr,
    countryCode: state.Framework.dealerCountry,
    loadingROs: state.RepairOrders.loadingROs,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    clearMainPanes: FrameworkActionCreator.clearMainPanes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    setViewMode: FrameworkActionCreator.acSetViewMode,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    getCustAppts: AppointmentActionCreator.GetCustAppts,
    setCustMode: FrameworkActionCreator.acSetCustMode,
    onCustUpdate: CustomerActionCreator.UpdateCustInfo,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    getVehicles: VehiclesActionCreator.GetVehicles,
    setVehNextAppt: VehiclesActionCreator.SetVehNextAppt,
    fetchROs: RepairOrdersActionCreator.FetchROs,
    selectRO: RepairOrdersActionCreator.SelectRO,
    clearCustInfo: CustomerActionCreator.ClearCustInfo,
    waitForLogOff: CustomerActionCreator.WaitForLogOff,
    logCustOff: CustomerActionCreator.LogCustOff,
    clearVehicles: VehiclesActionCreator.ClearVehicles,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
    clearApptState: AppointmentActionCreator.ClearApptState,
    clearROState: RepairOrdersActionCreator.ClearROState,
    clearROHistory: ROHistoryActionCreator.ClearROHistory,
    clearMenusState: MenusActionCreator.ClearMenusState,
    updateApptOps: AppointmentActionCreator.UpdateApptOps,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    generateUrl: FrameworkActionCreator.generateUrl,
    generateDocsUrl: FrameworkActionCreator.generateDocsUrl,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    clearNewTabUrl: FrameworkActionCreator.clearNewTabUrl,
    spmCustomerCentral: CustomerActionCreator.OEMCustomerSearch,
    viewVehicles: FrameworkActionCreator.ViewVehicles,
    setLoadingStateToIdle: CustomerActionCreator.SetLoadingStateToIdle,
    clearError: CustomerActionCreator.CustomerClearError,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(UserAccountMenu);